import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function WomenHub() {
  return (
    <>
      <Helmet defer={false}>
        <title>Women's Hormone Health by Decade | Hormonely</title>
        <meta name="description" content="Hormone health guides for women in their 40s, 50s and 60s. Plain English information about perimenopause, menopause and what to do about it." />
      </Helmet>

      <div className="page-hero">
        <div className="container page-hero__inner">
          <div className="eyebrow" style={{ color: 'var(--clay-lt)', marginBottom: '16px' }}>Women</div>
          <h1 className="page-hero__title">Your hormones by <em>decade</em></h1>
          <p className="page-hero__sub">Plain English guides to what's actually happening — and what to do about it. Start with the decade that matches where you are now.</p>
        </div>
      </div>

      <section className="section section--white">
        <div className="container">
          <div className="guides-grid">
            <Link to="/women-30s" className="guide-card">
              <span className="guide-card__decade">30s</span>
              <div className="guide-card__title">Women in their 30s</div>
              <div className="guide-card__topics">Fertility hormones, thyroid, early perimenopause signs, mood and energy</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/women-40s" className="guide-card">
              <span className="guide-card__decade">40s</span>
              <div className="guide-card__title">Women in their 40s</div>
              <div className="guide-card__topics">Perimenopause, oestrogen decline, HRT explained plainly, weight, sleep and brain fog</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/women-50s" className="guide-card">
              <span className="guide-card__decade">50s</span>
              <div className="guide-card__title">Women in their 50s</div>
              <div className="guide-card__topics">Menopause, what nobody tells you after the diagnosis, bone density and heart health</div>
              <span className="guide-card__arrow">→</span>
            </Link>
            <Link to="/women-60s" className="guide-card">
              <span className="guide-card__decade">60s</span>
              <div className="guide-card__title">Women in their 60s</div>
              <div className="guide-card__topics">Post-menopause health, bone density, cardiovascular risk, genitourinary symptoms and HRT after 60</div>
              <span className="guide-card__arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
